export default __webpack_public_path__ + "9b291b4494f7f8f0abfaa3698bedd622.svg";